<div class="container">
  <fgbcl-card-token-list
    [regex]="regex"
    [provider]="provider"
    [redirectUrl]="'/cardtoken/result'"
    [failureUrl]="'/cardtoken/failure'"
    [showExpiry]="true"
  ></fgbcl-card-token-list>

  <!-- <fgbcl-express-checkout-providers
    [providers]="providers"
    [failureUrl]="'/cardtoken/failure'"
    (result)="onExpressCheckoutResult($event)"
    (incomplete)="onExpressCheckoutIncomplete($event)"
  /> -->

  <div class="mt-10">
    <fgb-how-it-works></fgb-how-it-works>
  </div>
</div>
